import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { FaKey, FaUser, FaCog, FaSignOutAlt, FaUpload, FaImages, FaDatabase } from "react-icons/fa";
import { Badge } from "react-bootstrap";
import { useUploadContext } from "../context/UploadContext";
import "./Sidebar.css";

const Sidebar = ({ collapsed, setCollapsed, openUploadPanel }) => {
  const navigate = useNavigate();
  // blindagem: se o provider ainda não expôs a fila, vira []
  const { uploadQueue = [] } = useUploadContext?.() || { uploadQueue: [] };
  const pendingCount = Array.isArray(uploadQueue)
    ? uploadQueue.filter((i) => i?.status !== "completed").length
    : 0;

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("username");
    navigate("/", { replace: true });
    window.location.href = "/";
  };

  return (
    <div className={`sidebar ${collapsed ? "collapsed" : ""}`}>
      <div className="sidebar-header">
        {!collapsed && (
          <img src="/logo_viadrive_white.svg" alt="Logo" className="logo" />
        )}
        <button className="toggle-button" onClick={() => setCollapsed(!collapsed)}>
          ☰
        </button>
      </div>

      <div className="menu-wrapper">
        <ul className="nav-list">
          <li>
            <NavLink to="/dashboard" className="nav-link">
              <img src="/icons/dashboard-icon.png" alt="Dashboard" className="dropdown-icon" />
              {!collapsed && <span>Dashboard</span>}
            </NavLink>
          </li>

          <li>
            <NavLink to="/buckets" className="nav-link">
              <img src="/icons/bucket-icon2.png" alt="Buckets" className="dropdown-icon" />
              {!collapsed && <span>Buckets</span>}
            </NavLink>
          </li>

          <li>
  <NavLink to="/photos" className="nav-link">
    <FaImages className="icon" />
    {!collapsed && <span>Fotos</span>}
  </NavLink>
</li>

          <li>
            <NavLink to="/access-keys" className="nav-link">
              <FaKey className="icon" />
              {!collapsed && <span>Access Keys</span>}
            </NavLink>
          </li>

          <li>
            <NavLink to="/users" className="nav-link">
              <FaUser className="icon" />
              {!collapsed && <span>Usuários</span>}
            </NavLink>
          </li>

          <li>
            <NavLink to="/market-intelligence/census" className="nav-link">
              <FaDatabase className="icon" />
              {!collapsed && <span>Consulta Censitária</span>}
            </NavLink>
          </li>

          <li>
            <NavLink to="/settings" className="nav-link">
              <FaCog className="icon" />
              {!collapsed && <span>Configurações</span>}
            </NavLink>
          </li>

          <li>
            <button className="nav-link uploads-link" onClick={openUploadPanel}>
              <FaUpload className="icon" />
              {!collapsed && (
                <>
                  <span className="label">Uploads</span>
                  {pendingCount > 0 && (
                    <Badge pill className="uploads-badge">
                      {pendingCount}
                    </Badge>
                  )}
                </>
              )}
            </button>
          </li>

          <li>
            <NavLink to="/upgrade" className="nav-link">
              <img src="/icons/diamond-icon.png" alt="Upgrade" className="dropdown-icon" />
              {!collapsed && <span>Upgrade</span>}
            </NavLink>
          </li>

          <li>
            <NavLink to="/faturas" className="nav-link">
              <img src="/icons/receipt-icon.png" alt="Faturas" className="dropdown-icon" />
              {!collapsed && <span>Faturas</span>}
            </NavLink>
          </li>
        </ul>
      </div>

      <div className="logout-section">
        <button onClick={handleLogout} className="logout-button">
          <FaSignOutAlt className="icon" />
          {!collapsed && <span>Sair</span>}
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
